import * as PIXI from 'pixi.js-legacy';
import { inject, injectable } from 'inversify';
import {
    EASE,
    getTween,
    getTweenAsync,
} from '../../framework/src/modules/Tween';

@injectable()
export default class Board {    

    board: PIXI.Sprite;    
    lights: Array<PIXI.Sprite> = [];
    lightPositionX: Array<number> = [-61,-29,4,37,70];//[-57, -25, 8, 41, 74];
    lightPositionY: Array<number> = [-78,-55,-32]; // [-82, -59, -36];

    constructor() {
        // let backgroundBoard = PIXI.Texture.EMPTY;        
        // let boardLight = PIXI.Texture.EMPTY;      
    }

    loadData() {
        // let backgroundBoard = PIXI.Texture.from('lines_background');
        // let boardLight = PIXI.Texture.from('lines_light');

        // this.board.texture = backgroundBoard;
        // this.board.children.forEach((child) => { child['texture'] = boardLight; });

         // create 5 sprites for 5 lights
        for (let i = 0; i < 5; i++) {
            let tempLight = new PIXI.Sprite(PIXI.Texture.from('lines_light'));//PIXI.Texture.EMPTY);//boardLight);
            tempLight.name = "Board Light_"+i;
            tempLight.position.set(this.lightPositionX[i], -200);
            tempLight.alpha = 0;
            tempLight.anchor.set(0.5, 0.5);
            this.lights.push(tempLight);
        }

        // create board for the lights / background
        this.board = new PIXI.Sprite(PIXI.Texture.from('lines_background'));//PIXI.Texture.EMPTY);//backgroundBoard);
        this.board.name = "Board Table";
        this.board.anchor.set(0.5, 1);
        this.board.position.set(637,0);//(632, 0); //640, 0); //wrong size of the image is off center        

        this.board.addChild(...this.lights);        
    }

    async show(time2: number = 200) {
        if (this.board.y < 92) {
            await getTweenAsync(this.board, {y:this.board.height}, time2,EASE.LINEAR);
        }
    }

    // loop through lights !!! timer for lights if fast forward or normal speed , need to be used in future ?
    async line(lineIndex: Array<any>, time: number = 40) {
        for (let i = 0; i < this.lights.length; i++) {
            await this.animateLights(i, lineIndex[i]['offs'], time);
        }
    }

    async hide(time2: number = 200) {
        if (this.board.y > -100) {
            await getTweenAsync(this.board, {y: 0}, time2, EASE.LINEAR);
        }
    }

    async turnLightsOff() {
        for (let light of this.lights) {
            light.alpha = 0;
        }
    }

    // only one light per column , and it changes position depending on the symbol array info
    async animateLights(i: number, lineIndex: number, time: number) {
        this.lights[i].position.x = this.lightPositionX[i];
        this.lights[i].position.y = this.lightPositionY[
            lineIndex            
        ];
        await getTweenAsync(this.lights[i], { alpha: 1 }, time, EASE.LINEAR);
    }

    destroy(){
        for (let light of this.lights){
            light.visible = false;
            light.alpha = 0;
            light.destroy({children:true,baseTexture:true});
            // light.removeChildren();
            light = undefined;
        }        

        this.board.visible = false;
        this.board.alpha = 0;
        this.board.destroy({children:true, baseTexture:true});
        // this.board.removeChildren();
        this.board = undefined;
        
        this.lightPositionX.length = 0;
        this.lightPositionY.length = 0;
    }
}
